import { render, staticRenderFns } from "./ListadoPreguntasAsignadas.vue?vue&type=template&id=c2ab19b6&scoped=true"
import script from "./ListadoPreguntasAsignadas.vue?vue&type=script&lang=js"
export * from "./ListadoPreguntasAsignadas.vue?vue&type=script&lang=js"
import style0 from "./ListadoPreguntasAsignadas.vue?vue&type=style&index=0&id=c2ab19b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2ab19b6",
  null
  
)

export default component.exports